export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_LOGIN_MODAL_OPENED = 'SET_LOGIN_MODAL_OPENED'
export const LOGOUT = 'LOGOUT';
export const SET_REGISTER_MODAL_OPENED = 'SET_REGISTER_MODAL_OPENED';
export const DEAUTHENTICATE_USER = 'DEAUTHENTICATE_USER';
export const CHANGE_PASSWORD_MODAL_OPENED = 'CHANGE_PASSWORD_MODAL_OPENED';
export const START_LOAGIND_LOGIN = 'START_LOAGIND_LOGIN';
export const END_LOAGIND_LOGIN = 'END_LOAGIND_LOGIN';